import { useI18n } from '@/hooks/web/useI18n'
import { Layout } from '@/utils/routerHelper'

const { t } = useI18n()

const assetsCenterRouter: AppRouteRecordRaw[] = [
  // 资产中心
  {
    path: '/assets-center',
    component: Layout,
    name: 'assetsCenter',
    redirect: '/assets-center/database',
    meta: {
      icon: 'carbon:collapse-categories',
      title: t('router.assetsCenter'),
      alwaysShow: true,
      permission: ['ac']
    },
    children: [
      {
        path: 'metadata',
        name: 'DatabaseMetadata',
        component: () => import('@/views/AssetsCenter/DatabaseMetadata/index.vue'),
        meta: {
          icon: 'carbon:cloud-satellite',
          title: t('router.metadata'),
          permission: ['ac:me']
        }
      },
      {
        path: 'Knowledge-base',
        name: 'KnowledgeBase',
        component: () => import('@/views/AssetsCenter/KnowledgeBase/index.vue'),
        meta: {
          icon: 'carbon:db2-database',
          title: t('router.knowledgeBase'),
          permission: ['ac:kb']
        },
        children: [
          {
            path: 'edit-md',
            name: 'EditMarkdown',
            component: () =>
              import('@/views/AssetsCenter/KnowledgeBase/components/EditMarkdown/index.vue'),
            meta: {
              icon: 'carbon:document',
              title: t('router.editMarkdown'),
              hidden: true,
              permission: ['ac:ed']
            }
          }
        ]
      },
      {
        path: 'manufacturer-library',
        name: 'ManufacturerLibrary',
        component: () => import('@/views/AssetsCenter/ManufacturerLibrary/index.vue'),
        meta: {
          icon: 'carbon:assembly-cluster',
          title: t('router.manufacturerSLibrary'),
          permission: ['ac:ml']
        }
      },
      {
        path: 'integrated-library',
        name: 'IntegratedLibrary',
        component: () => import('@/views/AssetsCenter/IntegratedLibrary/index.vue'),
        meta: {
          icon: 'carbon:category',
          title: t('router.integratedLibrary'),
          permission: ['ac:il']
        }
      }
    ]
  }
]

export default assetsCenterRouter
